module.exports = __webpack_public_path__ + "img/icon_sports_football.e8b3e353.png";